import { Component, inject } from '@angular/core';
import { AppSvgIconComponent, BreadcrumbComponent } from '@vallift/ngl';
import { AccountMenuButtonComponent } from '../account-menu-button/account-menu-button';
import { LayoutService } from '../../layout.service';

@Component({
  selector: 'app-top-bar',
  standalone: true,
  imports: [
    BreadcrumbComponent,
    AccountMenuButtonComponent,
    AppSvgIconComponent,
  ],
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.scss',
})
export class TopBarComponent {
  readonly layoutService = inject(LayoutService);

  toggleMobileNav(): void {
    this.layoutService.toggleMobileNav();
  }
}
